import React from 'react';
import { pdfStyles } from '../styles';
import { Image, pdf, Text, View } from "@react-pdf/renderer";

const FirstTable = ({ user, photo, portfolio }) => {
    const phones = () => {
        return user['Phone cell'] ?
            user['Phone home'] ? `${user['Phone cell']} ${user['Phone home']}` : user['Phone cell']
            : user['Phone home'] ? user['Phone home'] : '-';
    };

    const firstTableData = [
        { name: `Направление подготовки /специальность`, text: user.faculty },
        { name: `Направленность / профиль /специализация`, text: portfolio.specialization },
        { name: `Уровень`, text: '-' },
        { name: `Курс`, text: user.yeducationyear },
        { name: `Учебная группа/отделение`, text: user.groupname },
        { name: `Форма обучения`, text: user.eduform },
        { name: `Год начала обучения `, text: portfolio['schoolYear'].split('-')[0] },
        { name: `Контактная информация`, text: phones() },
        { name: `Дополнительные сведения`, text: user.LookDescript },
    ];

    return (
        <View style={pdfStyles.table}>

            <View style={pdfStyles.tableHeadRow}>
                <View style={pdfStyles.tableCell}>
                    <View style={pdfStyles.tableCol80}>
                        <Text style={pdfStyles.headMargin}>
                            {`Курсант ${user.lastname} ${user.firstname} ${user.patronymic}`}
                        </Text>
                    </View>

                    {!!photo && <Image style={pdfStyles.avatar} src={photo} />}

                </View>
            </View>

            {firstTableData.map((item, index) => (
                <View style={{ ...pdfStyles.tableRowFirst, height: [0, 1, firstTableData.length - 1].includes(index) ? 60 : 'auto' }}>
                    <View style={[pdfStyles.tableCol50, pdfStyles.tableCol]}>
                        <View style={pdfStyles.tableCell}>
                            <Text>
                                {item.name}
                            </Text>
                        </View>
                    </View>
                    <View style={[pdfStyles.tableCol50, pdfStyles.tableCol]}>
                        <View style={pdfStyles.tableCell}>
                            <Text style={[0, 1, firstTableData.length - 1].includes(index) ? pdfStyles.text : null}>
                                {item.text}
                            </Text>
                        </View>
                    </View>
                </View>))}

        </View>
    );
};

export default FirstTable;